"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
/**
 * `List` component is a performant interface for rendering simple, flat lists. Extends `FlatList`. Renders list of
 * `ListItem` components or custom content.
 *
 * @extends React.Component
 *
 * @property {(info: ListRenderItemInfo<ItemT>, style: StyleType) => ReactElement} renderItem - Takes an
 * item from data and renders it into the list.
 *
 * @property {FlatListProps} ...FlatListProps - Any props applied to FlatList component.
 *
 * @overview-example ListSimpleUsage
 *
 * @overview-example ListCompositeItem
 *
 * @example ListInlineStyling
 * ```
 */
class ListComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.listRef = react_1.default.createRef();
        this.scrollToEnd = (params) => {
            this.listRef.current.scrollToEnd(params);
        };
        this.scrollToIndex = (params) => {
            this.listRef.current.scrollToIndex(params);
        };
        this.getComponentStyle = (source) => {
            return {
                container: source,
                item: {},
            };
        };
        this.getItemStyle = (source, index) => {
            const { item } = source;
            return item;
        };
        this.keyExtractor = (item, index) => {
            return index.toString();
        };
        this.renderItem = (info) => {
            const itemStyle = this.getItemStyle(this.props.themedStyle, info.index);
            const itemElement = this.props.renderItem(info, itemStyle);
            return react_1.default.cloneElement(itemElement, {
                style: [itemStyle, styles.item, itemElement.props.style],
                index: info.index,
            });
        };
    }
    scrollToOffset(params) {
        this.listRef.current.scrollToOffset(params);
    }
    render() {
        const { style, themedStyle, ...derivedProps } = this.props;
        const componentStyle = this.getComponentStyle(themedStyle);
        return (react_1.default.createElement(react_native_1.FlatList, Object.assign({ keyExtractor: this.keyExtractor }, derivedProps, { ref: this.listRef, style: [componentStyle.container, styles.container, style], renderItem: this.renderItem })));
    }
}
exports.ListComponent = ListComponent;
ListComponent.styledComponentName = 'List';
const styles = react_native_1.StyleSheet.create({
    container: {},
    item: {},
});
exports.List = theme_1.styled(ListComponent);
//# sourceMappingURL=list.component.js.map